(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/hooks/use-confirmed-order.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/hooks/use-confirmed-order.js');
"use strict";


const {
  useState,
  useEffect
} = React;
const {
  SHIPPING_COST,
  OrderType: {
    GIFT
  }
} = svs.ticketsOrderHome.utils.constants;
const {
  getOrderItemsAsync
} = svs.ticketsOrderHome.services;
const {
  getProductNameAndPrice
} = svs.ticketsOrderHome.utils;
const {
  useIsMounted
} = svs.ticketsOrderHome.hooks;
const formatGiftAddress = giftAddress => {
  if (!giftAddress) {
    return null;
  }
  return {
    name: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.firstName,
    surname: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.lastName,
    address: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.street,
    postcode: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.zipCode,
    location: giftAddress === null || giftAddress === void 0 ? void 0 : giftAddress.city
  };
};
const useConfirmedOrder = id => {
  const {
    resetState,
    state
  } = svs.ticketsOrderHome.context.useOrderHomeContext();
  const {
    order: {
      orderItems = [],
      referenceId,
      giftAddress: giftAddressState,
      isGift: isGiftState
    },
    availableTickets
  } = state;
  const [{
    loading,
    tickets,
    giftAddress,
    isGift
  }, setState] = useState({
    loading: true,
    tickets: [],
    giftAddress: giftAddressState,
    isGift: isGiftState
  });
  const isMounted = useIsMounted();
  useEffect(() => {
    const fetchOrderItems = async () => {
      let items = [];
      let tempGiftAddress;
      let tempIsGift;
      if (!id || id === referenceId && orderItems.length !== 0) {
        items = orderItems;
        tempGiftAddress = formatGiftAddress(giftAddressState);
        tempIsGift = Boolean(isGiftState);
      } else {
        try {
          const order = await getOrderItemsAsync(id);
          items = order.orderItems || [];
          tempGiftAddress = formatGiftAddress(order === null || order === void 0 ? void 0 : order.giftAddress);
          tempIsGift = order.orderType === GIFT;
        } catch (e) {
          items = [];
        }
      }
      const ticketsOrder = items.map(item => {
        const ticket = availableTickets.find(t => t.id == item.productCode);
        return {
          name: getProductNameAndPrice(ticket),
          count: item.quantity,
          totalPrice: item.quantity * (ticket === null || ticket === void 0 ? void 0 : ticket.price)
        };
      });
      if (isMounted()) {
        resetState();
        setState({
          loading: false,
          tickets: ticketsOrder,
          giftAddress: tempGiftAddress,
          isGift: tempIsGift
        });
      }
    };
    fetchOrderItems();
  }, []);
  const totalOrderPrice = tickets.reduce((a, t) => a + t.totalPrice, 0) + SHIPPING_COST;
  return {
    loading,
    tickets: loading ? [] : tickets,
    giftAddress,
    isGift,
    totalOrderPrice,
    shippingCost: SHIPPING_COST
  };
};
setGlobal('svs.ticketsOrderHome.hooks.useConfirmedOrder', useConfirmedOrder);

 })(window);